import { render, staticRenderFns } from "./IconComponentWText.vue?vue&type=template&id=32561019&"
import script from "./IconComponentWText.vue?vue&type=script&lang=js&"
export * from "./IconComponentWText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports